import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.customerGroup, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_CUSTOMER_GROUPS:
      return {
        ...state,
        customerGroups: payload.customerGroups,
        customerGroupsTotalCount: payload.customerGroupsTotalCount,
      };
    case types.GET_CUSTOMER_GROUP_DETAILS:
      return {
        ...state,
        details: payload.details,
      };
    case types.GET_CUSTOMER_GROUP_MEMBERS_SUCCESS:
      return {
        ...state,
        members: payload.members,
        totalMembersCount: payload.totalMembersCount,
      };
    case types.GET_CUSTOMER_GROUP_ADMINS_SUCCESS:
      return {
        ...state,
        admins: payload.admins,
        totalAdminsCount: payload.totalAdminsCount,
      };
    case types.DELETE_CUSTOMER_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        members: state.members.filter(({ id }) => id !== payload.id),
        totalMembersCount: state.totalMembersCount - 1,
      };
    case types.DELETE_CUSTOMER_GROUP_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.filter(({ id }) => id !== payload.id),
        totalAdminsCount: state.totalAdminsCount - 1,
      };
    case types.DELETE_CUSTOMER_GROUP_SUCCESS:
      return {
        ...state,
        customerGroups: state.customerGroups.filter(
          ({ id }) => id !== payload.id
        ),
        customerGroupsTotalCount: state.customerGroupsTotalCount - 1,
      };
    default:
      return state;
  }
}
